var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxIndeterminate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.42,
    height: 27.42,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 13,
    height: 13,
    rx: 1.5,
    stroke: "#052643"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8671 2H4.13291C2.95493 2 2 2.95493 2 4.13291V15.8671C2 17.0451 2.95493 18 4.13291 18H15.8671C17.0451 18 18 17.0451 18 15.8671V4.13291C18 2.95493 17.0451 2 15.8671 2Z",
    fill: "#0BFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 8,
    height: 1.5,
    fill: "#052643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIndeterminate);
export default __webpack_public_path__ + "static/media/checkbox_indeterminate.5640a6d7452e15dc30b3365769b79e43.svg";
export { ForwardRef as ReactComponent };